import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-archived",
  "use": "icon-archived-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 12 12\" id=\"icon-archived\"><path fill=\"#FF9E1B\" d=\"M6 0a6 6 0 100 12A6 6 0 006 0zm2.883 7.478l-.233.5A.107.107 0 018.5 8L5.616 6.774a.106.106 0 01-.045-.087V3c0-.059.049-.107.108-.107h.644c.059 0 .107.048.107.107v3.315l2.429 1.014c.048.034.059.1.024.149z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol